import React, { useEffect, useState } from "react";
import AdminSideBar from "../common/AdminSideBar";
import LogoutModal from "../ui/LogoutModal";
import { useAuthStore } from "../../context/useAuthStore";
import { Outlet } from "react-router-dom";

interface AdminDashboardLayoutProps {
  children?: React.ReactNode;
}

const AdminDashboardLayout: React.FC<AdminDashboardLayoutProps> = () => {
  const { user, logout } = useAuthStore();
  const [showModal, setShowModal] = useState(false);
  const [userName, setUserName] = useState<string>("");

  useEffect(() => {
    if (user) {
      setUserName(user.fullName || "Unknown User");
    } else {
      setUserName("User");
    }
  }, [user]);

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleLogoutClick = async () => {
    await logout();
    setShowModal(false);
  };

  return (
    <main className="dashboardLayoutContainer no-scrollbar">
      <AdminSideBar onLogout={() => setShowModal(true)} />
      <section className="dashboardLayoutSection p-4 no-scrollbar">
        <Outlet />
      </section>
      <LogoutModal
        userName={userName}
        showModal={showModal}
        onClose={handleModalClose}
        onLogout={handleLogoutClick}
      />
    </main>
  );
};

export default AdminDashboardLayout;
